import type { LabosDeviceKey, LabosNalogStatus, LabosUredaj } from "../../../Api/mes.api";
import { t, dateLocale } from "../../../i18n/locale";

export const TARGET_BRASNO_G: Record<LabosUredaj, number> = {
  farinograf: 300,
  ekstenzograf: 300,
  amilograf: 80,
};

export const UREDAJ_LABEL: Record<LabosUredaj, string> = {
  farinograf: "Farinograf",
  ekstenzograf: "Ekstenzograf",
  amilograf: "Amilograf",
};

export const DEVICE_LABEL: Record<LabosDeviceKey, string> = {
  farinograph: "Farinograf",
  extensograph: "Extensograf",
  amylograph: "Amilograf",
};

export const DEVICE_TABS: { key: LabosDeviceKey; label: string }[] = [
  { key: "farinograph", label: "Farinogram" },
  { key: "extensograph", label: "Ekstenzogram" },
  { key: "amylograph", label: "Amilogram" },
];

export const NALOG_STATUS_LABEL: Record<LabosNalogStatus, string> = {
  plan: "Plan",
  u_tijeku: "U tijeku",
  zavrseno: "Završeno",
  otkazano: "Otkazano",
};

export function formatLabosDateTime(ts?: string | null): string {
  if (!ts) return "—";
  return new Date(ts).toLocaleString(dateLocale(), {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatLabosDate(d?: string | null): string {
  if (!d) return "—";
  return new Date(d).toLocaleDateString(dateLocale());
}

export function validityBadge(isValid?: boolean | null): string {
  if (isValid === true) return "✅";
  if (isValid === false) return "❌";
  return "—";
}

export function uredajToDevice(uredaj: LabosUredaj): LabosDeviceKey {
  if (uredaj === "farinograf") return "farinograph";
  if (uredaj === "ekstenzograf") return "extensograph";
  return "amylograph";
}
